import { createSlice } from '@reduxjs/toolkit';

export const servicesIaPlansSlice = createSlice({
    name: 'servicesIaPlans',
    initialState: {
        plans_list: [],
        plan: {}
    },
    reducers: {
        setPlansListRedux: ( state, { payload } ) => {
            state.plans_list = payload;
        },
        setPlanRedux: ( state, { payload } ) => {
            state.plan = payload;
        }
    }
});

// Action creators are generated for each case reducer function
export const { setPlansListRedux, setPlanRedux } = servicesIaPlansSlice.actions;
